import api from "@/lib/axios";
import useAuth from "@/hooks/stores/useAuth";

let heartbeatInterval = null;
let activityTimeout = null;
let lastActivityTime = Date.now();
const IDLE_TIMEOUT = 2 * 60 * 1000; 
const HEARTBEAT_INTERVAL = 30 * 1000;

export const heartbeatService = {
  startHeartbeat() {
    const { userRole } = useAuth.getState();
    // console.log('Attempting to start heartbeat. Current role:', userRole);
    
  
    if (!userRole || userRole.toLowerCase() !== 'user') {
    //   console.log('Heartbeat not started - User role is not "user"');
      return;
    }

   
    if (heartbeatInterval) {
    //   console.log('Heartbeat is running so skip');
      return;
    }

    // first initializing activity tracking
    this.initializeActivityTracking();

    // for the first time sending heartbeat imideately
    this.sendHeartbeat()
      .then(() => console.log('Initial heartbeat sent successfully'))
      .catch(error => console.error('Initial heartbeat failed:', error));

    // for the main interval sending heartbeat
    heartbeatInterval = setInterval(() => {
      // Only send heartbeat if user is active and page is visible
      if (this.isUserActive() && !document.hidden) {
        const currentUserRole = useAuth.getState().userRole;
        if (!currentUserRole || currentUserRole.toLowerCase() !== 'user') {
          // console.log('User no longer has correct role, stopping heartbeat');
          this.stopHeartbeat();
          return;
        }

        this.sendHeartbeat()
          .then(() => console.log('Heartbeat sent successfully'))
          .catch(error => {
            console.error('Heartbeat failed:', error);
            // If we get a 401 or 403, stop the heartbeat
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              // console.log('Unauthorized/Forbidden response, stopping heartbeat');
              this.stopHeartbeat();
            }
          });
      }
    }, HEARTBEAT_INTERVAL);

    // for the page visibility change listener
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    // console.log('Heartbeat service started successfully');
  },

  stopHeartbeat() {
    if (heartbeatInterval) {
      clearInterval(heartbeatInterval);
      heartbeatInterval = null;
    //   console.log('Heartbeat service stopped');
    }
    
    if (activityTimeout) {
      clearTimeout(activityTimeout);
      activityTimeout = null;
    }

    // Removing all event listeners
    this.removeActivityTracking();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
  },

  initializeActivityTracking() {
    // List of the events to track
    const events = [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'click'
    ];

    // Bind the event handler to all events
    const boundHandleUserActivity = this.handleUserActivity.bind(this);
    events.forEach(event => {
      window.addEventListener(event, boundHandleUserActivity);
    });

    // Start checking for inactivity
    this.checkActivity();
  },

  removeActivityTracking() {
    const events = [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'click'
    ];

    const boundHandleUserActivity = this.handleUserActivity.bind(this);
    events.forEach(event => {
      window.removeEventListener(event, boundHandleUserActivity);
    });
  },

  handleUserActivity() {
    lastActivityTime = Date.now();
  },

  handleVisibilityChange() {
    if (!document.hidden) {
      // Page became visible - update last activity time
      this.handleUserActivity();
    }
  },

  isUserActive() {
    return (Date.now() - lastActivityTime) < IDLE_TIMEOUT;
  },

  checkActivity() {
    activityTimeout = setInterval(() => {
      if (!this.isUserActive()) {
        console.log('User is idle');
        // You could emit an event or call a callback here to notify about idle state
      }
    }, IDLE_TIMEOUT);
  },

  async sendHeartbeat() {
    try {
      const response = await api.get('/v1/heartbeat');
      return response.data;
    } catch (error) {
      console.error('Heartbeat request failed:', error);
      throw error;
    }
  }
}; 